var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"mb-1 iv-paragraph"},[_vm._v("回答締切")]),_c('p',{staticClass:"mb-4 mt-0 iv-paragraph"},[_vm._v(_vm._s(_vm.date))])])}
var staticRenderFns = []

export { render, staticRenderFns }